export default {"src":"/_next/static/media/tooltip-red.3be5ed6c.svg","height":30,"width":30};